import {
    createApi,
    fakeBaseQuery,
} from '@reduxjs/toolkit/query';
import {
    AbstractedHardwareOverviewResponse,
    GladosEndpointVersion,
    GladosServiceFactory,
    HardwareType,
    PriceType,
} from '@vfde-sails/glados-v2';
import { getQueryParam } from '@vfde-sails/utils';
import { IInitialState } from '../interfaces/state';
import {
    API_BTX_MULTICARD,
    API_SALESCHANNEL_CONSUMER,
    STONE_VIRTUAL_ID,
} from '@vfde-sails/constants';
import { miniSerializeError } from '@reduxjs/toolkit';

const gladosApi = createApi({
    reducerPath: 'GladosService',
    baseQuery: fakeBaseQuery(),
    endpoints: build => ({
        getDeviceOverview: build.query<AbstractedHardwareOverviewResponse, IInitialState['paymentMethod']>({
            queryFn: async paymentMethod => {
                const hardwareService = GladosServiceFactory.getHardwareService();



                try {
                    const response = await hardwareService.getHardwareOverview(GladosEndpointVersion.V1, {
                        btx: API_BTX_MULTICARD,
                        salesChannel: [API_SALESCHANNEL_CONSUMER],
                        hardwareTypes: [HardwareType.Smartwatch],
                        category: HardwareType.Smartwatch.toLowerCase(),
                        ...paymentMethod === PriceType.Monthly && { tariffIds: [STONE_VIRTUAL_ID] },
                    });



                    return { data: response.data };
                }
                catch (error) {
                    return { error: miniSerializeError(error) };
                }
            },
        }),
    }),
});

export default gladosApi;

export const {
    getDeviceOverview,
} = gladosApi.endpoints;
